import * as React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

import cx from 'classnames';

import { FieldErrorMessage } from 'components/Form/FieldErrorMessage/FieldErrorMessage';

import s from './Checkbox.module.css';

type CheckboxProps = {
  className?: string;
  error?: string;
  id: string;
  label: string | React.ReactNode;
  labelClassName?: string;
  name: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  register?: UseFormRegisterReturn;
  required?: boolean;
  value?: boolean;
  content?: React.ReactNode;
};

const Checkbox = ({
  className,
  error,
  id,
  label,
  labelClassName,
  name,
  onBlur,
  onChange,
  register,
  required,
  value,
  content,
}: CheckboxProps) => {
  return (
    <label
      htmlFor={id}
      className={cx(className, s.root, { [s.error]: !!s.error })}
    >
      <div className={s.container}>
        <div className={s.inputContainer}>
          <div className={s.checkmark} />
          <input
            className={s.input}
            type="checkbox"
            onChange={onChange}
            onBlur={onBlur}
            checked={value}
            name={name}
            id={id}
            required={required}
            {...register}
            aria-invalid={error ? 'true' : 'false'}
            aria-errormessage={error ? `error-${id}` : undefined}
          />
          <svg className={s.svg} viewBox="0 0 14 12">
            <path className={s.path} d="M1 5.71429L4.72414 9.57143L13 1" />
          </svg>
          <span className={cx(s.label, labelClassName)}>{label}</span>
        </div>
        {content ? <div className={s.content}>{content}</div> : null}
      </div>
      <FieldErrorMessage id={id} error={error} />
    </label>
  );
};

export { Checkbox };
